module.exports = __webpack_public_path__ + "img/picto_coche_select_btn_important.fc468fe8.svg";